/**
 * Emergent Google Auth callback handler.
 * Reads session_id from URL fragment, exchanges it with backend, then navigates.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        // Clear hash before navigating
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data.full_name || data.email}`);
        navigate("/my-orders", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <main className="bg-[#0A0A0A] min-h-screen flex items-center justify-center">
      <p className="font-body text-sm" style={{ color: "rgba(255,255,255,0.6)" }}>Signing you in…</p>
    </main>
  );
}
